
import { MESSAGE_TYPES } from 'components';
import { keyValueMirror } from 'store/store-functions';
import { addMessage, clearMessages } from './app';
import { actions as organzationActions } from './adminActions/organizations';
import { actions as oauthActions } from './adminActions/oauth';

const {
    VITE_API_DEV_HOST,
    VITE_AUTHENTICATION_HOST,
    VITE_CLIENT_ID: clientId,
} = process.env;

const baseUrl = VITE_API_DEV_HOST;

export const actions = keyValueMirror(
    'GET_USERS_ADMIN',
    'GET_TEAMS_ADMIN',
    'GET_TEAM_ID_ADMIN',
    'SET_IS_LOADING',
    'UPSERT_TEAM_MEMBER_ADMIN',
    'DELETE_TEAM_MEMBER_ADMIN',
    'UPDATE_TEAM_ID_ADMIN',
    'CREATE_TEAM_ADMIN',
    'CREATE_USER_ADMIN',
    'GET_PIPELINE_ADMIN',
    'GET_CREATORS_ADMIN',
    'CREATE_CREATOR_ADMIN',
    'FLUSH_PIPELINE_ADMIN',
    'GET_MODELS_ADMIN',
    'CLEAR_ADMIN_MODELS',
    'GET_JOBS_ADMIN',
    'GET_PREVIEWS_ADMIN',
    'IMPERSONATE_USER',
    ...organzationActions,
    ...oauthActions,
);

export const setIsLoading = value => ({
    type: actions.SET_IS_LOADING,
    payload: value,
});

export const clearAdminModels = () => ({ type: actions.CLEAR_ADMIN_MODELS });

export const getUsersAdmin = token => async dispatch => {
    const searchParams = new URLSearchParams(window.location.search);
    if (!searchParams.has('per_page')) searchParams.set('per_page', '50');
    if (!searchParams.has('sort') && !searchParams.has('orderby') && !searchParams.has('order')) {
        searchParams.set('orderby', 'registered_date');
        searchParams.set('order', 'desc');
    }
    const params = '?' + searchParams.toString();

    const url = `${baseUrl}/admin/users${params}`;
    const options = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        dispatch(setIsLoading(true));
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = 'Unable to retrieve ArchVision Users.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const data = await res.json();
        const action = { type: actions.GET_USERS_ADMIN, payload: data };
        dispatch(action);
    } catch (error) {
            const message = 'Unable to retrieve ArchVision Users.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
    } finally {
        dispatch(setIsLoading(false));
    }
};

export const getUserAdmin = (token, email) => async dispatch => {
    const params = new URLSearchParams({
        email,
        page: '1',
        per_page: '50',
        orderby: 'registered_date',
        order: 'desc',
    });
    const url = `${baseUrl}/admin/users?${params.toString()}`;
    const options = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        const res = await fetch(url, options);
        if (!res.ok) {
            const message = 'Unable to retrieve user.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
            return null;
        }

        const data = await res.json();
        return data.users?.[0] || null;
    } catch (error) {
        const message = 'Unable to retrieve user.';
        const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
        dispatch(addMessage([ { message, config } ]));
        return null;
    }
};

export const getTeamsAdmin = token => async dispatch => {

    const params = window.location.search;
    const url = `${baseUrl}/admin/teams${params}`;
    const options = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        dispatch(setIsLoading(true));
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = 'Unable to retrieve ArchVision Teams.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const data = await res.json();
        const action = { type: actions.GET_TEAMS_ADMIN, payload: data };
        dispatch(action);
    } catch (error) {
            const message = 'Unable to retrieve ArchVision Teams.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
    } finally {
        dispatch(setIsLoading(false));
    }
};

export const getTeamsIdAdmin = (token, teamId) => async dispatch => {
    const url = `${baseUrl}/admin/teams/${teamId}`;
    const options = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        dispatch(setIsLoading(true));
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = `Unable to retrieve team ${teamId}.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const data = await res.json();
        const action = { type: actions.GET_TEAM_ID_ADMIN, payload: data };
        dispatch(action);
    } catch (error) {
            const message = `Unable to retrieve team ${teamId}.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
    } finally {
        dispatch(setIsLoading(false));
    }
};

/**
 * Sends a request to upsert user data to the provided team ID
 *
 * @param {string} token - the user's token
 * @param {string} teamId - the ID of the team to upsert users to
 * @param {{email?: string, id?: integer, role: string}[]} userData - an array of user's data to upsert
 * }>}
 */
export const upsertTeamMemberAdmin = (token, teamId, userData) => async dispatch => {
    const url = `${baseUrl}/admin/teams/${teamId}/users`;

    const data = userData.map(user => {
        return { ...user };
    });

    const options = {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ users: data }),
    };
    try {
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = `Unable to upsert team members.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const action = { type: actions.UPSERT_TEAM_MEMBER_ADMIN };
        dispatch(action);
        dispatch(getTeamsIdAdmin(token, teamId));
    } catch (error) {
            const message = `Unable to upsert team members.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
    }
};

/**
 * Sends a request to remove a user from a team
 *
 * @param {string} token - the user's token
 * @param {string} teamId - the ID of the team to delete users from
 * @param {{id: integer}[]} userData - an array of user data with IDs to remove from the team
 * }>}
 */
export const deleteTeamMemberAdmin = (token, teamId, userData, onComplete) => async dispatch => {
    const url = `${baseUrl}/admin/teams/${teamId}/users`;

    const data = userData.map(user => {
        return { ...user };
    });

    const options = {
        method: 'DELETE',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ users: data }),
    };

    try {
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_url=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = `Unable to delete team members.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const data = await res.json();

        const action = { type: actions.DELETE_TEAM_MEMBER_ADMIN, payload: data };
        dispatch(action);
        dispatch(getTeamsIdAdmin(token, teamId));
    } catch (error) {
        const message = `Unable to delete team members.`;
        const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
        dispatch(addMessage([ { message,config } ]));
    } finally {
        onComplete?.();
    }
};

export const updateTeamIdAdmin = (token, teamId, updateData) => async dispatch => {
    const { displayName, domains } = updateData;
    const url = `${baseUrl}/admin/teams/${teamId}`;
    const options = {
        method: 'PUT',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            display_name: displayName,
            allowed_domains: domains,
        }),
    };

    try {
        const res = await fetch(url, options);
        if (!res.ok) {
            const message = `Unable to update team data.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(clearMessages());
            dispatch(addMessage([ { message, config } ]));
            return;
        }
        const action = { type: actions.UPDATE_TEAM_ID_ADMIN };
        dispatch(action);
        dispatch(getTeamsIdAdmin(token, teamId));

    } catch (err) {
        const message = err.message || 'Error updating team data.';
        const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
        dispatch(clearMessages());
        dispatch(addMessage([ { message, config } ]));
    }
};

/**
 * Creates a team using admin privileges
 * @param {string} token - user access token
 * @param {{name: string, allowedDomains: string[]}} teamData - the name and allowed domains for the team
 */
export const createTeamAdmin = (token, teamData) => async dispatch => {
    const url = `${baseUrl}/admin/teams`;
    const data = {
        name: teamData.name.replace(' ', '_'),
        display_name: teamData.name,
        allowed_domains: teamData.allowedDomains,
    };
    const options = {
        method:'POST',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    };

    try {
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = `Unable to create team.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const action = { type: actions.CREATE_TEAM_ADMIN };
        dispatch(action);
        dispatch(getTeamsAdmin(token));
    } catch (error) {
            const message = `Unable to create team.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
    }
};

/**
 * Creates a user using admin privileges
 * @param {string} token - user access token
 * @param {{email: string, firstName?: string, lastName?: string, role?: string}} userData
 */
export const createUserAdmin = (token, userData) => async dispatch => {
    const url = `${baseUrl}/admin/users`;

    const data = {
        email: userData.email?.trim(),
        role: (userData.role || 'registered')?.trim(),
        ...(userData.firstName ? { first_name: userData.firstName.trim() } : {}),
        ...(userData.lastName ? { last_name: userData.lastName.trim() } : {}),
    };

    const options = {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    };

    try {
        const res = await fetch(url, options);

        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = 'Unable to create user.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
            return;
        }


        dispatch({ type: actions.CREATE_USER_ADMIN });
        dispatch(getUsersAdmin(token)); // refresh list
    } catch (error) {
        const message = 'Unable to create user.';
        const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
        dispatch(addMessage([ { message, config } ]));
    }
};

export const addCreditsAdmin = (token, userId, credits) => async dispatch => {
    const url = `${baseUrl}/admin/users/${userId}/credits`;
    const options = {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ credits }),
    };

    try {
        const res = await fetch(url, options);

        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = 'Unable to add credits.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
            return;
        }

        const message = `Credits added successfully.`;
        const config = { type: MESSAGE_TYPES.success, timer: 2.5 };
        dispatch(addMessage([ { message, config } ]));
        dispatch(getUsersAdmin(token));
    } catch (error) {
        const message = 'Unable to add credits.';
        const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
        dispatch(addMessage([ { message, config } ]));
    }
};

/**
 * Mints a real user session for the target user without their password so an admin can
 * browse the app as that user. Returns the token payload on success (so the caller can swap
 * the current session), or null on any failure (an error message is surfaced here).
 *
 * @param {string} token - the admin's access token
 * @param {number} userId - the id of the user to impersonate
 * @returns {Promise<{access_token: string, refresh_token: string} | null>}
 */
export const impersonateUser = (token, userId) => async dispatch => {
    const url = `${baseUrl}/admin/users/${userId}/impersonate`;
    const options = {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        const res = await fetch(url, options);

        if (!res.ok) {
            // Distinct, non-redirecting handling for the "can't impersonate an admin" guardrail.
            if (res.status === 403) {
                const body = await res.json().catch(() => ({}));
                if (body?.error === 'cannot_impersonate_admin') {
                    const message = 'You cannot log in as another administrator.';
                    const config = { type: MESSAGE_TYPES.error, timer: 3 };
                    dispatch(addMessage([ { message, config } ]));
                    return null;
                }

                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return null;
            }

            const message = res.status === 404
                ? 'User not found.'
                : 'Unable to log in as user.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
            return null;
        }

        const data = await res.json();
        dispatch({ type: actions.IMPERSONATE_USER });
        return data;
    } catch (error) {
        const message = 'Unable to log in as user.';
        const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
        dispatch(addMessage([ { message, config } ]));
        return null;
    }
};

export const getPipelineAdmin = token => async dispatch => {
    const url = `${baseUrl}/admin/pipeline`;
    const options = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        dispatch(setIsLoading(true));
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = `Unable to retrieve pipeline data.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const data = await res.json();
        const action = { type: actions.GET_PIPELINE_ADMIN, payload: data };
        dispatch(action);
    } catch (error) {
            const message = `Unable to retrieve pipeline data.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
    } finally {
        dispatch(setIsLoading(false));
    }
};

export const getCreatorsAdmin = token => async dispatch => {

    const params = window.location.search;
    const url = `${baseUrl}/admin/creators${params}`;
    const options = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        dispatch(setIsLoading(true));
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = 'Unable to retrieve creators.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const data = await res.json();
        const action = { type: actions.GET_CREATORS_ADMIN, payload: data };
        dispatch(action);
    } catch (error) {
            const message = 'Unable to retrieve creators.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
    } finally {
        dispatch(setIsLoading(false));
    }
};

/**
 * Creates a creator using admin privileges
 * @param {string} token - user access token
 * @param {{
 *          name: string,
 *          subscriptionFormats: string[],
 *          purchaseFormats: string[]
 * }} creatorData - the name and allowed domains for the team
 */
export const createCreatorAdmin = (token, creatorData) => async dispatch => {
    const url = `${baseUrl}/admin/creators`;
    const data = {
        display_name: creatorData.name,
        search_name: creatorData.name.replace(' ', '_'),
        allowed_subscription_formats: creatorData.subscriptionFormats,
        allowed_purchase_formats: creatorData.purchaseFormats,
    };
    const options = {
        method:'POST',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    };

    try {
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = `Unable to create creator.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const action = { type: actions.CREATE_TEAM_ADMIN };
        dispatch(action);
        dispatch(getCreatorsAdmin(token));
    } catch (error) {
            const message = `Unable to create creator.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
    }
};

export const flushPipelineAdmin = (token, queueName, onComplete) => async dispatch => {
    const url = `${baseUrl}/admin/pipeline/${queueName}/flush`;
    const options = {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        const res = await fetch(url, options);
        if  (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = `Unable to flush ${queueName}.`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const action = { type: actions.FLUSH_PIPELINE_ADMIN };
        dispatch(action);
        dispatch(getPipelineAdmin(token));
    } catch (error) {
        const message = `Unable to flush ${queueName}.`;
        const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
        dispatch(addMessage([ { message, config } ]));
    } finally {
        onComplete?.();
    }
};

export const getTripoCreditsAdmin = token => async dispatch => {
    const url = `${baseUrl}/admin/ai/tripo/credits`;
    const options = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return null;
            }

            const message = 'Unable to retrieve AI model credits.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
            return null;
        }

        return await res.json();
    } catch (error) {
        const message = 'Unable to retrieve AI model credits.';
        const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
        dispatch(addMessage([ { message, config } ]));
        return null;
    }
};

export const getMeshyCreditsAdmin = token => async dispatch => {
    const url = `${baseUrl}/admin/ai/meshy/credits`;
    const options = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return null;
            }

            const message = 'Unable to retrieve AI model credits.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
            return null;
        }

        return await res.json();
    } catch (error) {
        const message = 'Unable to retrieve AI model credits.';
        const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
        dispatch(addMessage([ { message, config } ]));
        return null;
    }
};

export const getRodinCreditsAdmin = token => async dispatch => {
    const url = `${baseUrl}/admin/ai/rodin/credits`;
    const options = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return null;
            }

            const message = 'Unable to retrieve AI model credits.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
            return null;
        }

        return await res.json();
    } catch (error) {
        const message = 'Unable to retrieve AI model credits.';
        const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
        dispatch(addMessage([ { message, config } ]));
        return null;
    }
};

export const getModelsAdmin = token => async dispatch => {
    const searchParams = new URLSearchParams(window.location.search);
    if (!searchParams.has('per_page')) searchParams.set('per_page', '50');
    if (!searchParams.has('order_by')) searchParams.set('order_by', 'CREATED_NEW_TO_OLD');
    const params = '?' + searchParams.toString();
    const url = `${baseUrl}/admin/models${params}`;
    const options = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        dispatch(setIsLoading(true));
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_uri=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = 'Unable to retrieve models.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
        }

        const data = await res.json();
        const action = { type: actions.GET_MODELS_ADMIN, payload: data };
        dispatch(action);
    } catch (error) {
            const message = 'Unable to retrieve models.';
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
    } finally {
        dispatch(setIsLoading(false));
    }
};

export const getJobsAdmin = token => async dispatch => {
    const searchParams = new URLSearchParams(window.location.search);
    if (!searchParams.has('per_page')) searchParams.set('per_page', '50');
    if (!searchParams.has('order_by')) searchParams.set('order_by', 'CREATED_NEW_TO_OLD');
    const params = '?' + searchParams.toString();
    const url = `${baseUrl}/admin/jobs/${params}`;
    const options = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        dispatch(setIsLoading(true));
        console.log('Admin jobs URL:', url);
        const res = await fetch(url, options);
        if (!res.ok) {
            const errorBody = await res.text();

            console.error('Admin jobs request failed', {
                url,
                status: res.status,
                statusText: res.statusText,
                body: errorBody,
            });

            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_url=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = `Unable to retrieve jobs (${res.status}).`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
            return;
        }

        const data = await res.json();
        const action = { type: actions.GET_JOBS_ADMIN, payload: data };
        dispatch(action);
    } catch (error) {
        const message = 'Unable to retrieve jobs.';
        const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
        dispatch(addMessage([ { message, config } ]));
    } finally {
        dispatch(setIsLoading(false));
    }
};

export const getPreviewsAdmin = token => async dispatch => {
    const searchParams = new URLSearchParams(window.location.search);
    if (!searchParams.has('per_page')) searchParams.set('per_page', '50');
    if (!searchParams.has('order_by')) searchParams.set('order_by', 'CREATED_NEW_TO_OLD');
    const params = '?' + searchParams.toString();
    const url = `${baseUrl}/admin/previews${params}`;
    const options = {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    };

    try {
        dispatch(setIsLoading(true));
        const res = await fetch(url, options);
        if (!res.ok) {
            if (res.status === 403) {
                const message = 'Unauthorized access. Redirecting...';
                const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
                dispatch(addMessage([ { message, config } ]));
                setTimeout(() => {
                    window.location.href = VITE_AUTHENTICATION_HOST +
                        '/oauth/authorize/?response_type=token&' +
                        `client_id=${clientId}&` +
                        `redirect_url=${window.location.origin}`;
                }, 2.5 * 1000);
                return;
            }

            const message = `Unable to retrieve previews (${res.status}).`;
            const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
            dispatch(addMessage([ { message, config } ]));
            return;
        }

        const data = await res.json();
        dispatch({ type: actions.GET_PREVIEWS_ADMIN, payload: data });
    } catch (error) {
        const message = 'Unable to retrieve previews.';
        const config = { type: MESSAGE_TYPES.error, timer: 2.5 };
        dispatch(addMessage([ { message, config } ]));
    } finally {
        dispatch(setIsLoading(false));
    }
};